import { Action, applyMiddleware, compose, createStore } from 'redux';

import { RootState } from './types';
import { createBrowserHistory } from 'history';
import { persistStore } from 'redux-persist';
import { rootReducer } from './rootReducer';
import { rootSaga } from './rootSaga';
import { createReduxHistoryContext } from 'redux-first-history';
import thunk from 'redux-thunk';
import createSagaMiddleware from 'redux-saga';

const { createReduxHistory, routerMiddleware, routerReducer } = createReduxHistoryContext({
  history: createBrowserHistory(),
});

const sagaMiddleware = createSagaMiddleware();

let middleware;
if (process.env.NODE_ENV !== 'production') {
  const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  middleware = composeEnhancers(applyMiddleware(routerMiddleware, sagaMiddleware, thunk));
} else {
  middleware = applyMiddleware(routerMiddleware, sagaMiddleware, thunk);
}

export const store = createStore<RootState, Action, any, any>(rootReducer(routerReducer), {} as any, middleware);
export const persistor = persistStore(store);
export const history = createReduxHistory(store);

sagaMiddleware.run(rootSaga);
